import { isClient } from '../utils/isClient'
import { _fetch } from '../lib/axios'

export const decodeGuestSessionToken = async (
   guestSessionToken,
   GRAPHQL_HTTP_URL
) => {
   try {
      const response = await _fetch(
         `${new URL(GRAPHQL_HTTP_URL).origin}/server/api/auth/verify`,
         {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: guestSessionToken }),
         }
      )

      if (response.status === 200) {
         const data = await response.json()
         if (data.payload && data.success) {
            return data.payload
         }
      } else {
         return {}
      }
   } catch (error) {
      console.log('[Error in decode token]', error)
      return {}
   }
}

export const getCookies = () => {
   const _cookies = {}
   if (isClient && document.cookie) {
      let cookies = document.cookie.split(';')
      for (let cookie of cookies) {
         cookie = cookie.trim()
         let [key, value] = cookie.split('=')
         _cookies[key] = value
      }
   }
   return _cookies
}

export const checkIfTokenExpired = token => {
   if (token) {
      const payload = JSON.parse(window.atob(token.split('.')[1]))
      if (payload.exp < new Date().getTime() / 1000) {
         return true
      }
   }
   return false
}
